import { render, staticRenderFns } from "./ReportHC.vue?vue&type=template&id=779137d8&scoped=true&"
import script from "./ReportHC.vue?vue&type=script&lang=js&"
export * from "./ReportHC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779137d8",
  null
  
)

export default component.exports